import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPicker, Input } from "uxp/components";
import { findAvailableFields, IPropertyEditorProps, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionEditorLink, { IAction } from "../../../common/action-editor/ActionEditor";
import { bindContainerId } from "../../../../util";
import { Conditional } from "../../../common/ConditionalComponent";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";
import { MultipleItemsProperty } from "../../../common/ui-fields/item-card-field/MultipleItemsProperty";
import { ICFButton } from "../../../common/ui-fields/item-card-field/ItemCard";
import IconEditor from "../../../common/icon-selector/IconEditor";

export interface IItemListProps {
    max: number,
    usePaginations: boolean,
    profileNameField: string,

    // Note: these fields are converted into pill input values
    titleField: string,
    subTitleField: string,
    profileImageField: string,

    dateField: string,
    statusField: string,
    status: Array<{ status: string, color: string }>
    onClickRow?: IAction,
    buttons?:ICFButton[],
}

export function ListProperty(title: string, props: IItemListProps): IUIPropertyDefinition<IItemListProps> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();


            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>

                    <Property>
                        <PropertyTitle>Use Pagination</PropertyTitle>

                        <Checkbox
                            checked={_props.usePaginations}
                            onChange={s => {
                                jp.apply(_props, '$.usePaginations', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Conditional visible={_props.usePaginations}>
                        <Property>
                            <PropertyTitle>Num. of items to load (page size)</PropertyTitle>

                            <Input
                                type="number"
                                value={_props.max?.toString() || '0'}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    jp.apply(_props, '$.max', () => (num))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    </Conditional>

                    <Property id={bindContainerId('fields', containerId)} styles={{ padding: '2px' }} >
                        <Property>
                            <PropertyTitle>Profile Image</PropertyTitle>
                            <WidgetDesignerPillInput
                                value={_props.profileImageField}
                                onChange={s => {
                                    jp.apply(_props, '$.profileImageField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Profile Name Field</PropertyTitle>

                            <WidgetDesignerPillInput
                                value={_props.profileNameField}
                                onChange={s => {
                                    jp.apply(_props, '$.profileNameField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Title</PropertyTitle>
                            <WidgetDesignerPillInput
                                value={_props.titleField}
                                onChange={s => {
                                    jp.apply(_props, '$.titleField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Sub Title</PropertyTitle>
                            <WidgetDesignerPillInput
                                value={_props.subTitleField}
                                onChange={s => {
                                    jp.apply(_props, '$.subTitleField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Date</PropertyTitle>

                            <WidgetDesignerPillInput
                                value={_props.dateField}
                                onChange={s => {
                                    jp.apply(_props, '$.dateField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Status Field</PropertyTitle>

                            <WidgetDesignerPillInput
                                value={_props.statusField}
                                onChange={s => {
                                    jp.apply(_props, '$.statusField', () => (s))
                                    props.onChange(_props)
                                }}
                                className={'widget-designer-pill-input'}
                                contextData={contextData}
                            />

                        </Property>
                    </Property>

                    <Property>
                        <PropertyTitle>On click an item </PropertyTitle>
                        <ActionEditorLink
                            uiProps={props.parentUIProps}
                            designer={props.designer}
                            uxpContext={uxpContext}
                            action={_props.onClickRow}
                            onChange={s => {
                                jp.apply(_props, '$.onClickRow', () => (s))
                                props.onChange(_props)
                            }}
                            contextData={contextData}
                        />
                    </Property>

                </PropertyGroup>

                <PropertyGroup>
                    <div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Status

                        <div className="plus" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                            onClick={() => {

                                let _status = _props.status || []
                                _status.unshift({ status: 'status', color: '' })

                                jp.apply(_props, `$.status`, () => (_status))
                                props.onChange(_props)
                            }}
                        >
                            <FontAwesomeIcon icon={['fas', 'plus']} />
                        </div>

                    </div>

                    <Property>
                        <PropertyTitle>Status & color</PropertyTitle>

                        <div className="wd-item-list-config-status-colors">

                            {_props.status.map((s, i) => {

                                return <div className="row">
                                    <div className="status">

                                        <Input
                                            value={s.status}
                                            onChange={(s) => {
                                                jp.apply(_props, `$.status[${i}].status`, () => (s))
                                                props.onChange(_props)
                                            }}
                                            className="status-input"
                                        />
                                    </div>
                                    <div className="color">
                                        <ColorPicker
                                            color={s.color}
                                            onChange={(s) => {
                                                jp.apply(_props, `$.status[${i}].color`, () => (s))
                                                props.onChange(_props)
                                            }}
                                            className='color-input'
                                            position='right'
                                        />
                                    </div>

                                    <div className="close"
                                        onClick={() => {
                                            let _status = _props.status || []
                                            _status.splice(i, 1)

                                            jp.apply(_props, `$.status`, () => (_status))
                                            props.onChange(_props)
                                        }}
                                    >
                                        <FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
                                    </div>
                                </div>
                            })}
                        </div>

                    </Property>

                </PropertyGroup>
                <PropertyGroup>
                    <PropertyGroupTitle>Buttons</PropertyGroupTitle>
                <Property>
                <MultipleItemsProperty<ICFButton>
                    items={_props?.buttons || []}
                    newItem={() => ({
                        icon: 'play',
                        color: "#424242",
                        backgroundColor: "#EEE",
                        onClick: { type: "open-url", redirectUrl: { url: 'about:blank' } }
                    })}
                    onChange={(items) => {
                        props.onChange({ ..._props, buttons: items });
                    }}
                    render={(item, onChange) => {
                        return <div className='cf-label-item'>


                            <div className='cf-m-f'>
                                <label>Icon</label>
                                <IconEditor onChange={(s) => onChange({ ...item, icon: s })} value={item.icon} />
                            </div>
                            <div className='cf-m-f'>
                                <label>Icon Color</label>
                                <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, color: s })} color={item.color} />
                            </div>
                            <div className='cf-m-f'>
                                <label>Icon Background</label>
                                <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, backgroundColor: s })} color={item.backgroundColor} />
                            </div>
                            <div className='cf-m-f'>
                                <ActionEditorLink
                                    uiProps={props.parentUIProps}
                                    uxpContext={props?.uxpContext}
                                    action={item.onClick}
                                    onChange={(s) => onChange(Object.assign({}, item, { onClick: s }))}
                                    contextData={props?.contextData}
                                />
                            </div>

                        </div>

                    }}
                    title=""

                />
            </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    };
}

interface ITextFieldProperty {
    color: string,
    size: string,
    align: string,
    useStatusColor: boolean
}
export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITextFieldProperty>> = (props) => {

    return <PropertyContainer>
        <PropertyGroup>
            <Property>
                <PropertyTitle>Color </PropertyTitle>

                <Checkbox
                    checked={props.uiProps?.useStatusColor || false}
                    onChange={s => props.onChange(Object.assign({}, props.uiProps, { useStatusColor: s }))}
                    label={"Use status color"}
                    type="bordered"
                />

                <CustomColorPicker contextData={props.contextData}
                    color={props.uiProps.color || ''}
                    onChange={s => props.onChange(Object.assign({}, props.uiProps, { color: s }))}
                />
            </Property>
            <Property>
                <PropertyTitle>Font size (px) </PropertyTitle>
                <Input
                    type='number'
                    value={escapeUnit(props.uiProps.size || '', 'px')}
                    onChange={s => {
                        let num = Number(s) || 0
                        if (num < 8) s = '8'
                        else if (num > 200) s = '200'

                        props.onChange(Object.assign({}, props.uiProps, { size: num + 'px' }))
                    }}
                    className="widget-designer-input"
                    inputAttr={{
                        max: '200',
                        min: '8'
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Align</PropertyTitle>
                <TextAlignEditor
                    value={props.uiProps.align || 'left'}
                    onChange={s => props.onChange(Object.assign({}, props.uiProps, { align: s }))}
                />
            </Property>

        </PropertyGroup>
    </PropertyContainer>;
}